import { Bundle } from './bundle';

export class Application {
  id: number;
  name: string;
  description: string;
  username: string;
  password: string;
  credits: number;
  created_at: Date;
  updated_at: Date;

  constructor() {
    this.id = 0;
    this.name = '';
    this.description = '';
    this.username = '';
    this.password = '';
    this.credits = 0;
    this.created_at = new Date();
    this.updated_at = new Date();
  }

  getToken() {
    return btoa(`${this.username}:${this.password}`);
  }
}
